import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    text: "Pensé que mi hijo 'era de poco dormir', hasta que leí la sección de regresiones de los 4 meses. En 3 días pasamos de 6 despertares a solo 1. No lo puedo creer.",
    name: 'Lucía M.',
    meta: 'Mamá de Mateo, 5 meses',
    initial: 'L'
  }, {
    text: 'Las tablas de ventanas de sueño me cambiaron la vida. Por fin entendí por qué siempre terminaba con un bebé sobreestimulado a la hora de dormir. ¡Gracias!',
    name: 'Valentina R.',
    meta: 'Mamá de Sofía, 8 meses',
    initial: 'V'
  }, {
    text: 'Lo que más me gustó fue que no me pedía dejar llorar a mi bebé. Es un enfoque respetuoso y con base real. Lo recomiendo a todas las mamás de mi grupo.',
    name: 'Ana C.',
    meta: 'Mamá de Diego, 14 meses',
    initial: 'A'
  }];
  return <section className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-navy to-navy-mid relative overflow-hidden" data-id="element-275">
      {/* Huge background quote mark */}
      <div className="absolute -top-10 -left-5 font-serif text-[300px] md:text-[400px] text-white/5 leading-none pointer-events-none select-none" data-id="element-276">
        "
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-277">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20" data-id="element-278">
          <FadeIn direction="up" data-id="element-279">
            <div className="text-center" data-id="element-280">
              <div className="font-serif text-4xl md:text-5xl font-black text-gold mb-2" data-id="element-281">
                2,000+
              </div>
              <div className="text-sm text-white/60 leading-snug" data-id="element-282">
                Mamás que ya
                <br data-id="element-283" />
                duermen mejor
              </div>
            </div>
          </FadeIn>
          <FadeIn delay={0.1} direction="up" data-id="element-284">
            <div className="text-center" data-id="element-285">
              <div className="font-serif text-4xl md:text-5xl font-black text-gold mb-2" data-id="element-286">
                4.9★
              </div>
              <div className="text-sm text-white/60 leading-snug" data-id="element-287">
                Calificación
                <br data-id="element-288" />
                promedio
              </div>
            </div>
          </FadeIn>
          <FadeIn delay={0.2} direction="up" data-id="element-289">
            <div className="text-center" data-id="element-290">
              <div className="font-serif text-4xl md:text-5xl font-black text-gold mb-2" data-id="element-291">
                &lt; 7 días
              </div>
              <div className="text-sm text-white/60 leading-snug" data-id="element-292">
                Para ver los
                <br data-id="element-293" />
                primeros resultados
              </div>
            </div>
          </FadeIn>
        </div>

        <div className="h-px bg-white/10 mb-16" data-id="element-294" />

        <FadeIn data-id="element-295">
          <div className="text-center mb-12" data-id="element-296">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white" data-id="element-297">
              Lo que dicen
              <br data-id="element-298" />
              otras mamás <span className="text-gold italic" data-id="element-299">como tú</span>
            </h2>
          </div>
        </FadeIn>

        {/* Real Mockup Photo - Before Pricing */}
        <FadeIn delay={0.2} data-id="element-300">
          <div className="max-w-2xl mx-auto mb-16 rounded-2xl overflow-hidden shadow-2xl border border-white/10" data-id="element-301">
            <img src="https://cdn.magicpatterns.com/uploads/pb5xVAsyhHvyn8iTdTu2Uq/heylloyd-image-1772909489716.png" alt="Mamá aliviada saliendo de la habitación donde su bebé duerme tranquilo gracias a la Guía del Sueño" className="w-full h-auto" data-id="element-302" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-303">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-304">
              <article className="bg-white/5 border border-white/10 rounded-2xl p-7 backdrop-blur-md transition-all duration-300 hover:bg-white/10 hover:-translate-y-1 h-full flex flex-col" data-id="element-305">
                <div className="text-gold tracking-widest mb-4" data-id="element-306">★★★★★</div>
                <blockquote className="text-sm text-white/80 leading-relaxed italic mb-6 flex-1" data-id="element-307">
                  "{testimonial.text}"
                </blockquote>
                <div className="flex items-center gap-3" data-id="element-308">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose to-gold flex items-center justify-center font-bold text-white text-sm flex-shrink-0" data-id="element-309">
                    {testimonial.initial}
                  </div>
                  <div data-id="element-310">
                    <div className="font-semibold text-white text-sm" data-id="element-311">
                      {testimonial.name}
                    </div>
                    <div className="text-xs text-white/45" data-id="element-312">
                      {testimonial.meta}
                    </div>
                  </div>
                </div>
              </article>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}